// 跳转只携带业务编号，不携带姓名、手机号、身份证号或完整查询结果。
function routeQueryText(value, maxLength) {
  if (typeof value !== "string") return "";
  const text = value.trim();
  const hasControlCharacters = Array.from(text).some((character) => {
    const code = character.charCodeAt(0);
    return code < 32 || (code >= 127 && code <= 159);
  });
  return text && text.length <= maxLength && !hasControlCharacters ? text : "";
}

export function taskManagementRoute(taskId) {
  if (typeof taskId !== "string" && typeof taskId !== "number") return null;
  if (typeof taskId === "number" && !Number.isSafeInteger(taskId)) return null;
  const id = routeQueryText(String(taskId), 19);
  // 全程按字符串处理长 ID；只为有效的正整数任务主键提供链接。
  if (!/^[1-9]\d*$/.test(id)) return null;
  if (id.length === 19 && id > "9223372036854775807") return null;
  return { path: "/infoAq/taskMgt", query: { taskId: id } };
}

export function orderManagementRoute(order) {
  if (!order || order.orderNo === null || order.orderNo === undefined)
    return null;
  const orderNo = routeQueryText(String(order.orderNo), 255);
  // shotTypeCode 是订单自己的拍摄类型：0 校拍、1 散拍，未知值不能默认归为校拍。
  const paths = { 0: "/infoAq/orderMgt", 1: "/infoAq/orderSpMgt" };
  if (
    !orderNo ||
    !Object.prototype.hasOwnProperty.call(paths, order.shotTypeCode)
  )
    return null;
  return { path: paths[order.shotTypeCode], query: { orderNo } };
}

/** 两个订单管理页接收相同的订单号参数，但始终使用各自的校拍/散拍类型。 */
export function orderLookupRouteMixin(shotTypeCode) {
  const routePath =
    shotTypeCode === "0" ? "/infoAq/orderMgt" : "/infoAq/orderSpMgt";
  return {
    data() {
      return { orderQuerySequence: 0 };
    },
    watch: {
      "$route.query.orderNo"(orderNo) {
        if (this.$route.path === routePath) this.applyRouteOrderQuery(orderNo);
      },
    },
    methods: {
      applyRouteOrderQuery(value) {
        if (value === null || value === undefined || value === "") return false;
        const orderNo = routeQueryText(value, 255);
        if (!orderNo) {
          this.$message.warning("跳转的订单号格式不正确，请手工查询");
          return false;
        }
        // 不沿用页面之前的姓名、学校或状态筛选，防止这些条件遮住指定订单。
        this.searchData = { orderNo, shotTypeCode };
        this.currentPage = 1;
        this.tableSelection = [];
        this.query();
        return true;
      },
    },
  };
}
